import React from "react";
import { UserPageWrapper } from "../_pageWrappers/UserPageWrapper";
import { UserToken } from "../../amorg-common";
import { Flex } from "../../designSystem/compositeComponents/FlexHelpers";
import { PageHeader } from "../../designSystem/PageHeader";
import { PageSection } from "../../designSystem/PageSection";
import { P } from "../../designSystem/typography/Body";
import { ProtectedPageContext } from "../_contexts/ProtectedPageContext";
import { SingleColumnLayout } from "../_layouts/SingleColumnLayout";
import { Link } from "../../designSystem/Link";

export function SupportPage(): JSX.Element  {

    return (
        <UserPageWrapper breadCrumbs={[{ text: 'Support', url: '' }]}>
            <SupportPageView />;
        </UserPageWrapper>
    );
}

export function SupportPageView():JSX.Element
{
    const context = React.useContext(ProtectedPageContext);
    const activeUser: UserToken | null = context?.user ?? null;
    
    const showArticlesSupport = activeUser?.features.includes('Articles');

    return (
        <>
            <PageHeader
                narrow
                headerIcon={"support"}
                headerText={"Har du brug for hjælp?"}
            />
            <SingleColumnLayout narrow>

                {showArticlesSupport && (
                    <PageSection
                        headerStyleVariant="card"
                        contentStyleVariant="card"
                        header={{
                            title:"Hjælp til Lovservice"
                        }}>
                            <Flex flexDirection="column" gap={16}>
                                <P>Hvis du skal bruge hjælp til Lovservice, kan du finde vejledning, ressourcer og kontaktoplysninger her</P>
                                <Link href="https://amorg.dk/support/lovservice" target="_blank">
                                    https://amorg.dk/support/lovservice
                                </Link>
                            </Flex>
                    </PageSection>
                )}

                <PageSection
                    headerStyleVariant="card"
                    contentStyleVariant="card"
                    header={{
                        title:"Teknisk hjælp til brug af AMORG platformen"
                    }}>

                    <Flex flexDirection="column" gap={16}>
                    <P>
                    Hvis du har spørgsmål eller brug for assistance, er vi her for at hjælpe. <br/>
                    Send os en e-mail på <a href="mailto:support@amorg.dk">support@amorg.dk</a>, og vi vender tilbage så hurtigt som muligt.
                    </P>
                    
                    <P>
                        Vi er dedikerede til at sikre, at du får den bedst mulige oplevelse med vores løsning.
                    </P>
                    </Flex>
                </PageSection>

            </SingleColumnLayout>
        </>
    );
}